import {
  GetMealResponseData,
  GetMealResponseDataDDChargeableMealListInner,
  GetMealResponseDataDDPreorderMealListInner,
  GetOrderResponseData,
  Traveler,
} from 'src/sdk-servicing';
import { AirportI18n } from '../master/airport_i18n_all';
import { MListData } from '../master/m_listdata';
import { MSpecialMeal } from '../master/m_special_meal';

export interface UpdateFlightMealInformation {
  // 申込操作中フラグ
  isApplicationProcessed?: boolean;
  airBoundId?: string;
  segmentMap?: Map<string, SegmentMap>;
}
export interface PassengerApplicationStatusMap {
  /** 機内食種別 */
  mealType?: string;
  /** SSRコード */
  ssrCode?: string;
  /** 事前ミールメッセージID */
  mealMessageId?: string;
  /** 有料サービス金額 */
  paidServiceAmount?: number;
  /** 更新区分 */
  updateCategory?: string;
  /** ベビーミール選択フラグ */
  babyMealSelectionFlag?: boolean;
}

export interface MealCatalogItem {
  // SSRコード
  ssrCode?: string;
  // 在庫数
  quota?: number;
}

export interface SegmentMap {
  passengerApplicationStatusMap: Map<string, PassengerApplicationStatusMap>;
  // 有料機内食カタログ情報
  mealCatalog?: MealCatalogItem[];
}

export interface MasterDataS02M017 {
  listData?: Array<MListData>;
  airportI18nAll?: AirportI18n;
  mSpecialMeal?: Array<MSpecialMeal>;
}

export interface ListSpecialMeal {
  type?: string;
  code?: string;
  mealName?: string;
  isActive?: boolean;
}
export interface DisplayedPreOrderMealList extends GetMealResponseDataDDPreorderMealListInner {
  isActive: boolean;
  type: string;
}
export interface DisplayedSpecialMealList {
  title?: string;
  listSpecialMeal?: Array<ListSpecialMeal>;
}
export interface DisplayedPaidMealList extends GetMealResponseDataDDChargeableMealListInner {
  isActive: boolean;
  type: string;
  mealName: string;
}
export interface SpecialMeal {
  code?: string;
}
export interface GetMealResponseDataDDSpecialMealListInner {
  [key: string]: Array<SpecialMeal>;
}

export interface InFlightMealRequestData {
  pnr?: GetOrderResponseData;
  meal?: GetMealResponseData;
  travelers?: Array<Traveler>;
}
export const INITIAL_FLIGHT_MEAL_SERVICE_REQUEST_MASTER_DATA: MasterDataS02M017 = {
  listData: [],
  airportI18nAll: undefined,
  mSpecialMeal: [],
};

export interface canSelectAllMealByTraveler {
  /** key is TravelerID */
  [key: string]: canSelectMealByFlight;
}

export interface canSelectMealByFlight {
  /** key is FlightID */
  [key: string]: boolean;
}

export interface InnerSpecialMealList {
  code: string[];
}
